export const URL = {
    PATIENT_SECURITY: "https://www.accurx.com/security-for-patients",
    NHS_LOGIN_HELP: "https://help.login.nhs.uk/",
    NHS_MANAGE_ACCOUNT: "https://settings.login.nhs.uk/",
} as const;
